var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#368a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "369b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#369b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#025BC2",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCD715",
    fillRule: "evenodd",
    d: "M0 16h22V0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24663A",
    fillRule: "evenodd",
    d: "M2.095 16H22V2.132z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m5.366 6.035-.647.364.123-.772-.524-.546.723-.113.325-.702.325.702.723.113-.524.546.123.772zM3.271 3.9l-.648.365.124-.772-.524-.546.723-.113.325-.702.325.702.722.113-.523.546.123.772zm4.19 0-.647.365.123-.772-.523-.546.722-.113.325-.702.325.702.723.113-.524.546.124.772zm0 4.267-.647.365.123-.772-.523-.547.722-.113.325-.702.325.702.723.113-.524.547.124.772zm-4.19 0-.648.365.124-.772-.524-.547.723-.113.325-.702.325.702.722.113-.523.547.123.772z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "368a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagSb = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagSb);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";